import { FunctionComponent } from 'react';
import OtherTransactionInfo from './OtherTransactionInfo';

const OtherTransactionContainer: FunctionComponent = () => {
  return (
    <div>
      <OtherTransactionInfo />
    </div>
  );
};

export default OtherTransactionContainer;
